<template>
  <div class="ricerca col-24 no-padding">
    <ricerca-panel :filtri="filtriRicerca"
                   @closeRicerca="closeRicerca"
                   @changeValueOrClick="changeValueOrClick"
                   @cerca="cerca"></ricerca-panel>
  </div>
</template>

<script>
  import RicercaPanel from '@/components/ServiceComponents/RicercaPanel'
  import {bus} from '../../../Bus.js'

  export default {
    name: 'Ricerca',
    components: {RicercaPanel},
    i18n: {
      messages: {
        it_IT: {
          ricerca: {
            filtri: 'Filtri',
            statoNazione: 'Stato',
            codForn: 'Codice Fornitore',
            fornitore: 'Fornitore / Sub-fornitore',
            soc: 'Società',
            mag: 'Magazzino',
            numOrd: 'Numero Ordine',
            annoOrd: 'Anno Ordine',
            dipendente: 'Dipendente',
            generici: 'Mostra generici',
            attivi: 'Solo Ordini Attivi',
            statoCat: 'Stato Categorizzazione',
            Y: 'Si',
            N: 'No',
            ALL: 'Tutti',
            RIC: 'Solo Documenti Richiesti',
            S1: 'In attesa di Approvazione',
            S2: 'Documenti in Regola',
            S3: 'Documenti Scaduti',
            cerca: 'Cerca',
            scegli: 'Scegli...'
          }
        },
        fr_FR: {
          ricerca: {
            filtri: 'Filtres',
            statoNazione: 'Pays',
            codForn: 'Code du Fournisseur',
            fornitore: 'fournisseur / Sous-traitant',
            soc: 'Société',
            mag: 'Entrepôt',
            numOrd: 'Numéro de commande',
            annoOrd: 'Année de commande',
            dipendente: 'Employé',
            generici: 'Afficher générique',
            attivi: 'Seulement les Commandes Actives',
            statoCat: 'Catégorisation du statut',
            Y: 'Oui',
            N: 'Non',
            ALL: 'Tous',
            RIC: 'Seuls les documents requis',
            S1: "Document en cours d'approbation",
            S2: 'Document en ordre',
            S3: 'Document expiré',
            cerca: 'Recherche',
            scegli: 'Choisir...'
          }
        },
        es_ES: {
          ricerca: {
            filtri: 'Filtros',
            statoNazione: 'País',
            codForn: 'Código de Proveedor',
            fornitore: 'Proveedor / Subcontratista',
            soc: 'Sociedad',
            mag: 'Almacén',
            numOrd: 'Número de orden',
            annoOrd: 'Año de la orden',
            dipendente: 'Empleado',
            generici: 'Mostrar genérico',
            attivi: 'Solo Pedidos Activos',
            statoCat: 'Categorización de estado',
            Y: 'Si',
            N: 'No',
            ALL: 'Todos',
            RIC: 'Solo los documentos requeridos',
            S1: 'Documentos bajo aprobación',
            S2: 'Documentos en orden',
            S3: 'Documentos caducado',
            cerca: 'Búsqueda',
            scegli: 'Elegir...'
          }
        },
        de_DE: {
          ricerca: {
            filtri: 'Filter',
            statoNazione: 'Land',
            codForn: 'Lieferantencode',
            fornitore: 'Lieferant / Subunternehmer',
            soc: 'Gesellschaft',
            mag: 'Warenhaus',
            numOrd: 'Bestellnummer',
            annoOrd: 'Bestelljahr',
            dipendente: 'Mitarbeiter',
            generici: 'Generisches anzeigen',
            attivi: 'Nur Aktive Bestellungen',
            statoCat: 'Statuskategorisierung',
            Y: 'Ja',
            N: 'Nein',
            ALL: 'Alle',
            RIC: 'Nur Dokumente erforderlich',
            S1: 'Dokument in Genehmigung',
            S2: 'Dokumente in Ordnung',
            S3: 'Abgelaufenes Dokument',
            cerca: 'Suche',
            scegli: 'Wählen...'
          }
        },
        en_GB: {
          ricerca: {
            filtri: 'Filters',
            statoNazione: 'Country',
            codForn: 'Supplier Code',
            fornitore: 'Supplier / Subcontractor',
            soc: 'Society',
            mag: 'Warehouse',
            numOrd: 'Order number',
            annoOrd: 'Order year',
            dipendente: 'Employee',
            generici: 'Show generic',
            attivi: 'Only Active Orders',
            statoCat: 'Status Categorization',
            Y: 'Yes',
            N: 'No',
            ALL: 'All',
            RIC: 'Only Documents Required',
            S1: 'Documents under approval',
            S2: 'Documents in order',
            S3: 'Expired Documents',
            cerca: 'Search',
            scegli: 'Choose...'
          }
        }
      }
    },
    props: {
      prefixApp: {
        type: String
      }
    },
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        codForn: '',
        codFornAdmin: {},
        firstLoad: true,
        filtriRicerca: {
          loading: true,
          titolo: '',
          valueSelected: {
            0: '',
            1: {},
            2: '',
            3: {codSoc: '', desDoc: ''},
            4: {codMag: '', desMag: ''},
            5: '',
            6: '',
            7: '',
            8: '',
            9: '',
            10: ''
          },
          dati: {
            0: [],
            1: [],
            2: [],
            3: [],
            4: [],
            8: [],
            9: [],
            10: []
          },
          filtri: [
            // Select con le country a cui è abilitato l'utente
            {
              type: 'select',
              myLabel: '',
              value: 'country',
              label: 'desc',
              key: 'country',
              onChangeOrClick: 'changeCountry',
              ifClearable: false,
              ifDisabled: false
            },
            // Select con i fornitori
            {
              type: 'select-with-object',
              myLabel: '',
              value: '',
              label: ['codForn', 'desForn'],
              key: 'codForn',
              onChangeOrClick: 'changeCodForn',
              ifClearable: false,
              ifDisabled: false,
              ifShow: false
            },
            // Select Fotrnitori / Sub-fornitori
            {
              type: 'select',
              myLabel: '',
              value: 'codForn',
              label: 'desForn',
              key: 'codForn',
              ifClearable: false,
              ifDisabled: false
            },
            // Select con le Società
            {
              type: 'select-with-object',
              myLabel: '',
              value: '',
              label: ['codSoc', 'desSoc'],
              key: 'codSoc',
              onChangeOrClick: 'changeSocieta',
              ifClearable: true,
              ifDisabled: true,
              ifShow: true
            },
            {
              type: 'select-with-object',
              myLabel: '',
              value: '',
              label: ['codMag', 'desMag'],
              key: 'codMag',
              ifClearable: true,
              ifDisabled: true,
              ifShow: true
            },
            // Numero Ordine
            {
              type: 'input',
              myLabel: '',
              ifClearable: true
            },
            // Anno Ordine
            {
              type: 'input',
              myLabel: '',
              ifClearable: true
            },
            // Dipendente
            {
              type: 'input',
              myLabel: '',
              ifClearable: true
            },
            // Documenti Richiesti
            {
              type: 'select',
              myLabel: '',
              value: 'value',
              label: 'label',
              key: 'value',
              ifClearable: false,
              ifDisabled: false
            },
            // Solo Ordini Attivi
            {
              type: 'select',
              myLabel: '',
              value: 'value',
              label: 'label',
              key: 'value',
              ifClearable: false,
              ifDisabled: false
            },
            // Stato Categorizzazione
            {
              type: 'select',
              myLabel: '',
              value: 'value',
              label: 'label',
              key: 'value',
              ifClearable: false,
              ifDisabled: false
            }
          ]
        }
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
        this.$nextTick(() => {
          this.getCountries(true)
          this.setTraduzioniLabel()
          let obj = [{
            value: 'Y',
            label: this.$i18n.messages[this.codLang].ricerca.Y
          }, {
            value: 'N',
            label: this.$i18n.messages[this.codLang].ricerca.N
          }]
          let objCat = [{
            value: 'ALL',
            label: this.$i18n.messages[this.codLang].ricerca.ALL
          }, {
            value: 'RIC',
            label: this.$i18n.messages[this.codLang].ricerca.RIC
          }, {
            value: '1',
            label: this.$i18n.messages[this.codLang].ricerca.S1
          }, {
            value: '2',
            label: this.$i18n.messages[this.codLang].ricerca.S2
          }, {
            value: '3',
            label: this.$i18n.messages[this.codLang].ricerca.S3
          }]
          this.$set(this.filtriRicerca.dati, 8, obj)
          this.$set(this.filtriRicerca.dati, 9, obj)
          this.$set(this.filtriRicerca.dati, 10, objCat)
        })
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
          this.$set(this, 'codForn', this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]])
        } else {
          this.$set(this, 'codFornAdmin', {})
          this.$set(this, 'codForn', '')
        }
        if (!this._inactive) {
          this.$set(this.filtriRicerca.dati, 1, [])
          this.$set(this.filtriRicerca.dati, 2, [])
          this.$set(this.filtriRicerca.dati, 3, [])
          this.$set(this.filtriRicerca.dati, 4, [])
          this.$set(this.filtriRicerca.valueSelected, 1, {})
          this.$set(this.filtriRicerca.valueSelected, 2, '')
          this.$set(this.filtriRicerca.valueSelected, 3, {codSoc: '', desDoc: ''})
          this.$set(this.filtriRicerca.valueSelected, 4, {codMag: '', desMag: ''})
          this.$set(this.filtriRicerca.valueSelected, 5, '')
          this.$set(this.filtriRicerca.valueSelected, 6, '')
          this.$set(this.filtriRicerca.valueSelected, 7, '')
          this.$set(this.filtriRicerca.valueSelected, 8, 'Y')
          this.$set(this.filtriRicerca.valueSelected, 9, 'Y')
          this.$set(this.filtriRicerca.valueSelected, 10, 'RIC')
          if (this.codForn) {
            this.getSubfornitori()
            this.getSocieta()
          }
        }
      })
    },
    activated: function () {
      this.init()
    },
    methods: {
      init: function () {
        this.$store.dispatch('ifObject', 'DOC_Ricerca').then((ifRicerca) => {
          if (ifRicerca) {
            let form = this.$store.state.DOC_Ricerca
            this.$set(this, 'codForn', form.codForn)
            this.$set(this.filtriRicerca.valueSelected, 0, form.country)
            let fornObj = {
              codForn: form.codForn,
              desForn: ''
            }
            this.$set(this.filtriRicerca.valueSelected, 1, fornObj)
            this.$set(this.filtriRicerca.valueSelected, 2, form.fornitore)
            this.$set(this.filtriRicerca.valueSelected, 3, {codSoc : form.codSoc, desSoc : form.desSoc})
            this.$set(this.filtriRicerca.valueSelected, 4, {codMag : form.codMag, desMag : form.desMag})
            this.$set(this.filtriRicerca.valueSelected, 5, form.numOrd)
            this.$set(this.filtriRicerca.valueSelected, 6, form.annoOrd)
            this.$set(this.filtriRicerca.valueSelected, 7, form.dipendente)
            this.$set(this.filtriRicerca.valueSelected, 8, form.generici)
            this.$set(this.filtriRicerca.valueSelected, 9, form.attivi)
            this.$set(this.filtriRicerca.valueSelected, 10, form.statoCat)
          } else {
            this.$set(this.filtriRicerca.valueSelected, 0, '')
            this.$set(this.filtriRicerca.valueSelected, 1, {})
            this.$set(this.filtriRicerca.valueSelected, 2, '')
            this.$set(this.filtriRicerca.valueSelected, 3, {codSoc : '', desSoc : ''})
            this.$set(this.filtriRicerca.valueSelected, 4, {codMag : '', desMag : ''})
            this.$set(this.filtriRicerca.valueSelected, 5, '')
            this.$set(this.filtriRicerca.valueSelected, 6, '')
            this.$set(this.filtriRicerca.valueSelected, 7, '')
            this.$set(this.filtriRicerca.valueSelected, 8, 'Y')
            this.$set(this.filtriRicerca.valueSelected, 9, 'Y')
            this.$set(this.filtriRicerca.valueSelected, 10, 'RIC')
          }

          // Se esiste nel localStorage l'oggetto amministrazione lo setto
          if (localStorage.hasOwnProperty('amministrazione')) {
            this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
          }

          // Chiamo il servizio per la lista degli Stati a cui sono abilitato passando come parametro false (NON sto cambiando lingua)
          this.getCountries(false)

          // Chiamo il metodo per settare le traduzioni delle label nella lingua impostata
          this.setTraduzioniLabel()

          this.$nextTick(() => {
            let obj = [{
              value: 'Y',
              label: this.$i18n.messages[this.codLang].ricerca.Y
            }, {
              value: 'N',
              label: this.$i18n.messages[this.codLang].ricerca.N
            }]
            let objCat = [{
              value: 'ALL',
              label: this.$i18n.messages[this.codLang].ricerca.ALL
            }, {
              value: 'RIC',
              label: this.$i18n.messages[this.codLang].ricerca.RIC
            }, {
              value: '1',
              label: this.$i18n.messages[this.codLang].ricerca.S1
            }, {
              value: '2',
              label: this.$i18n.messages[this.codLang].ricerca.S2
            }, {
              value: '3',
              label: this.$i18n.messages[this.codLang].ricerca.S3
            }]
            this.$set(this.filtriRicerca.dati, 8, obj)
            this.$set(this.filtriRicerca.dati, 9, obj)
            this.$set(this.filtriRicerca.dati, 10, objCat)
          })
        })
      },
      setTraduzioniLabel: function () {
        this.$set(this.filtriRicerca, 'titolo', this.$t('ricerca.filtri'))
        this.$set(this.filtriRicerca.filtri[0], 'myLabel', this.$t('ricerca.statoNazione'))
        this.$set(this.filtriRicerca.filtri[1], 'myLabel', this.$t('ricerca.codForn'))
        this.$set(this.filtriRicerca.filtri[2], 'myLabel', this.$t('ricerca.fornitore'))
        this.$set(this.filtriRicerca.filtri[3], 'myLabel', this.$t('ricerca.soc'))
        this.$set(this.filtriRicerca.filtri[4], 'myLabel', this.$t('ricerca.mag'))
        this.$set(this.filtriRicerca.filtri[5], 'myLabel', this.$t('ricerca.numOrd'))
        this.$set(this.filtriRicerca.filtri[6], 'myLabel', this.$t('ricerca.annoOrd'))
        this.$set(this.filtriRicerca.filtri[7], 'myLabel', this.$t('ricerca.dipendente'))
        this.$set(this.filtriRicerca.filtri[8], 'myLabel', this.$t('ricerca.generici'))
        this.$set(this.filtriRicerca.filtri[9], 'myLabel', this.$t('ricerca.attivi'))
        this.$set(this.filtriRicerca.filtri[10], 'myLabel', this.$t('ricerca.statoCat'))
      },
      closeRicerca: function () {
        this.$emit('closeRicerca')
      },
      cerca: function () {
        let form = {
          country: this.filtriRicerca.valueSelected[0],
          codForn: this.codForn,
          fornitore: this.filtriRicerca.valueSelected[2] ? this.filtriRicerca.valueSelected[2] : '',
          codSoc: this.filtriRicerca.valueSelected[3].codSoc ? this.filtriRicerca.valueSelected[3].codSoc : '',
          desSoc: this.filtriRicerca.valueSelected[3].desSoc ? this.filtriRicerca.valueSelected[3].desSoc : '',
          codMag: this.filtriRicerca.valueSelected[4].codMag ? this.filtriRicerca.valueSelected[4].codMag : '',
          desMag: this.filtriRicerca.valueSelected[4].desMag ? this.filtriRicerca.valueSelected[4].desMag : '',
          numOrd: this.filtriRicerca.valueSelected[5] ? this.filtriRicerca.valueSelected[5] : '',
          annoOrd: this.filtriRicerca.valueSelected[6] ? this.filtriRicerca.valueSelected[6] : '',
          dipendente: this.filtriRicerca.valueSelected[7] ? this.filtriRicerca.valueSelected[7].toUpperCase() : '',
          generici: this.filtriRicerca.valueSelected[8] ? this.filtriRicerca.valueSelected[8] : '',
          attivi: this.filtriRicerca.valueSelected[9] ? this.filtriRicerca.valueSelected[9] : '',
          statoCat: this.filtriRicerca.valueSelected[10] ? this.filtriRicerca.valueSelected[10] : ''
        }
        this.$store.commit('set', {key: 'DOC_Ricerca', value: form})
        // sessionStorage.setItem('AnagDip_form', JSON.stringify(form))
        this.$emit('cerca')
      },
      changeValueOrClick: function (index) {
        if (this.filtriRicerca.filtri[index].hasOwnProperty('onChangeOrClick')) {
          this[this.filtriRicerca.filtri[index].onChangeOrClick]()
        }
      },
      getCountries: function (ifChangeLang) {
        this.$http.get('portale/countries', {
          params: {
            codLang: this.codLang,
            codiApp: 'WebDocRichiesti'
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              this.$set(this.filtriRicerca.dati, 0, data)
              if (data.length > 0) {
                this.$store.dispatch('ifObject', 'DOC_Ricerca').then((ifRicerca) => {
                  // Se NON c'è una ricerca già salvata in VUEX
                  if (!ifRicerca) {
                    // Verifico se lo Stato impostato nel localStorage esiste tra quelli restituiti dal servizio delle abilitazioni
                    let flag = data.some(e => e.country === localStorage.getItem('ACCSTA_country'))
                    // Se flag = true uso lo Stato del localStorage
                    this.$set(this.filtriRicerca.valueSelected, 0, flag ? localStorage.getItem('ACCSTA_country') : data[0].country)
                  }
  
                  // Se NON sto cambiando lingua procedo, altrimenti tolgo il loader
                  if (!ifChangeLang) {
                    this.getFornitoreInfo(false)
                  } else {
                    this.$set(this.filtriRicerca, 'loading', false)
                  }
                })
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      /*  Al momento del cambio della country vengono azzerati array e valori in richiamare i servizi
       */
      changeCountry: function () {
        this.$set(this.filtriRicerca.dati, 1, [])
        this.$set(this.filtriRicerca.dati, 2, [])
        this.$set(this.filtriRicerca.dati, 3, [])
        this.$set(this.filtriRicerca.dati, 4, [])
        this.$set(this.filtriRicerca.valueSelected, 1, {})
        this.$set(this.filtriRicerca.valueSelected, 2, '')
        this.$set(this.filtriRicerca.valueSelected, 3, {codSoc: '', desDoc: ''})
        this.$set(this.filtriRicerca.valueSelected, 4, {codMag: '', desMag: ''})
        this.$set(this.filtriRicerca.valueSelected, 5, '')
        this.$set(this.filtriRicerca.valueSelected, 6, '')
        this.$set(this.filtriRicerca.valueSelected, 7, '')
        this.$set(this.filtriRicerca.valueSelected, 8, 'Y')
        this.$set(this.filtriRicerca.valueSelected, 9, 'Y')
        this.$set(this.filtriRicerca.valueSelected, 10, 'RIC')

        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codForn', this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]])
        }
  
        this.$store.commit('set', {key: 'DIP_Ricerca', value: {}})
        this.$store.commit('set', {key: 'DIP_Dipendente', value: {}})
        this.$store.commit('set', {key: 'DIP_new', value: false})
        this.$store.commit('set', {key: 'DIP_Documento', value: {}})
        this.$store.commit('set', {key: 'DOC_Ricerca', value: {}})
        this.$store.commit('set', {key: 'GA_Documento', value: {}})
        this.$store.commit('set', {key: 'ASD_Ricerca', value: {}})
        sessionStorage.removeItem('ACCSTA_fornitore')
  
        this.getFornitoreInfo(true)
      },
      getFornitoreInfo: function (ifChangeCountry) {
        this.$set(this.filtriRicerca, 'loading', true)
        this.$http.get('documentirichiesti/info', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0]
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              // Se utente è FORNITORE o AGENTE
              if (response.body.attrib.typeOfUser === 'fornitore') {
                let data = response.body.data
                this.$set(this.filtriRicerca.dati, 1, data)
                this.$set(this.filtriRicerca.filtri[1], 'ifDisabled', (data.length <= 1))
                this.$set(this.filtriRicerca.filtri[1], 'ifShow', true)

                this.$store.dispatch('ifObject', 'DOC_Ricerca').then((ifRicerca) => {
                  // Se NON c'è una ricerca salvata in VUEX oppure sto cambiando Stato
                  if (!ifRicerca || ifChangeCountry) {
                    // Se esiste un codForn ACCSTA salvato
                    if (sessionStorage.hasOwnProperty('ACCSTA_fornitore')) {
                      let ACCSTA_fornitore = sessionStorage.getItem('ACCSTA_fornitore')
                      let flag = false
                      data.forEach((forn) => {
                        if (forn.codForn === ACCSTA_fornitore) {
                          flag = true
                          this.$set(this.filtriRicerca.valueSelected, 1, forn)
                          this.$set(this, 'codForn', forn.codForn)
                        }
                      })
                      if (!flag) {
                        this.$set(this.filtriRicerca.valueSelected, 1, data[0])
                        this.$set(this, 'codForn', data[0].codForn)
                      }
                    }
                    // Se NON esiste un codForn ACCSTA salvato
                    else {
                      this.$set(this.filtriRicerca.valueSelected, 1, data[0])
                      this.$set(this, 'codForn', data[0].codForn)
                    }
                  }
  
                  if (this.codForn) {
                    this.getSubfornitori(ifChangeCountry)
                    this.getSocieta()
                  } else {
                    this.$emit('loadingOff')
                    this.$set(this.filtriRicerca, 'loading', false)
                  }
                })
              }
              // Utente AMMINISTRATORE
              else if (response.body.attrib.typeOfUser === 'admin') {
                // Se esiste l'oggetto amministrazione e il codForn ACCSTA per lo Stato selezionato è valorizzato allora lo uso
                if (localStorage.hasOwnProperty('amministrazione') && this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]]) {
                  this.$set(this, 'codForn', this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]])
                }
  
                this.$set(this.filtriRicerca.filtri[1], 'ifShow', false)

                if (this.codForn) {
                  this.getSubfornitori(ifChangeCountry)
                  this.getSocieta()
                } else {
                  this.$emit('loadingOff')
                  this.$set(this.filtriRicerca, 'loading', false)
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      getSubfornitori: function (ifChangeCountry) {
        this.$http.get('documentirichiesti/subfornitori', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0],
            codForn: this.codForn
          }
        })
          .then(response => {
            if (response.body.rc === 0 && response.body.data.length > 0) {
              let data = response.body.data
              this.$set(this.filtriRicerca.dati, 2, data)
              this.$store.dispatch('ifObject', 'DOC_Ricerca').then((ifRicerca) => {
                // Se non è salvata una ricerca in VUEX la lancio
                if (!ifRicerca) {
                  this.$set(this.filtriRicerca.valueSelected, 2, data[0].codForn)
                  // Se NON sto cambiando stato effettuo la ricerca
                  if (!ifChangeCountry) {
                    this.cerca()
                  }
                }
              })
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      getSocieta: function () {
        this.$set(this.filtriRicerca, 'loading', true)
        this.$http.get('documentirichiesti/societa', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0],
            codForn: this.codForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this.filtriRicerca.dati, 3, response.body.data)
              this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', false)
              let codSoc = this.filtriRicerca.valueSelected[3].codSoc
              if (response.body.data.length > 0 && codSoc) {
                this.getMagazzini()
              } else {
                this.$set(this.filtriRicerca, 'loading', false)
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      /*  Al cambio della società viene richiamata la getMagazzini solo nel caso in cui si sia solo modificato il codSoc
       e non cancellato, altrimenti vengono azzerati l'array dei magazzini e il codMag
       */
      changeSocieta: function () {
        this.$set(this.filtriRicerca.valueSelected, 4, {codMag: '', desMag: ''})
        if (this.filtriRicerca.valueSelected[3].codSoc) {
          this.getMagazzini()
        } else {
          this.$set(this.filtriRicerca.dati, 4, [])
          this.$set(this.filtriRicerca.filtri[4], 'ifDisabled', true)
        }
      },
      getMagazzini: function () {
        this.$set(this.filtriRicerca, 'loading', true)
        this.$http.get('documentirichiesti/magazzini', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0],
            codSoc: this.filtriRicerca.valueSelected[3].codSoc,
            codForn: this.codForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this.filtriRicerca.dati, 4, response.body.data)
              if (response.body.data.length > 0) {
                this.$set(this.filtriRicerca.filtri[4], 'ifDisabled', false)
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this.filtriRicerca, 'loading', false)
          })
      },
      changeCodForn: function () {
        this.$set(this, 'codForn', this.filtriRicerca.valueSelected[1].codForn)

        this.$set(this.filtriRicerca.dati, 2, [])
        this.$set(this.filtriRicerca.dati, 3, [])
        this.$set(this.filtriRicerca.dati, 4, [])
        this.$set(this.filtriRicerca.valueSelected, 2, '')
        this.$set(this.filtriRicerca.valueSelected, 3, {codSoc: '', desDoc: ''})
        this.$set(this.filtriRicerca.valueSelected, 4, {codMag: '', desMag: ''})
  
        this.getSubfornitori()
        this.getSocieta()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../../assets/less/general.less";

  .ricerca {
    height: 100%;
    position: absolute;
    z-index: 10;
    .header-tab {
      height: 65px;
      border-bottom: 1px solid #007c74;
      text-align: center;
      .icon-search {
        line-height: 65px;
        .el-button {
          height: 40px;
          width: 40px;
          border-radius: 0px;
          margin-top: 12px;
          margin-left: 10px;
          padding: 0px;
          color: @greenRiva;
          float: left;
          border: 1px solid @greenRiva;
        }
        .el-button:hover {
          background-color: @white;
        }
      }
    }
    .el-table::before {
      height: 0px;
    }
    .el-table {
      border-bottom: none;
      height: 430px;
      overflow: auto;
      .el-table__fixed-right {
        box-shadow: none;
        -webkit-box-shadow: none;
        .el-table__fixed-body-wrapper {
          top: 41px;
        }
      }
      .el-table__fixed-right::before {
        height: 0px;
      }
      .el-table__header {
        border-bottom: 1px solid @greenRiva;
        thead {
          th {
            padding: 5px 0px 0px 0px;
            &:not(.is-sortable) {
              .cell {
                margin-top: -7px;
              }
            }
            .cell {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-left: 10px !important;
              .set-font(@color: @greenRiva; @weight: bold; @size: 12px);
            }
          }
        }
      }
      .el-table__body {
        tbody {
          tr {
            &.expanded {
              background-color: #e7e7e7;
              td {
                background-color: #e7e7e7 !important;
              }
            }
            &.hover-row {
              td {
                background-color: @white;
              }
            }
            &.single {
              .el-table__expand-icon {
                display: none;
              }
            }
            td {
              padding-top: 5px;
              padding-bottom: 5px;
              .cell {
                .set-font(@size: 12px; @color: #606266);
                .pointer:hover {
                  cursor: pointer;
                }
                .fa-icon {
                  margin-top: 4px;
                }
              }
              -webkit-transition: none;
              transition: none;
            }
            .el-table__expanded-cell {
              padding: 0px !important;
              .el-table__header-wrapper {
                display: none;
              }
              .el-table {
                height: auto !important;
                .el-table__body {
                  tr {
                    td {
                      border-bottom: 0px;
                      &.cella-evidenziata {
                        background-color: #e7e7e7;
                      }
                    }
                  }
                }
              }
              .el-table::before {
                height: 0px;
              }
              .el-table__empty-block {
                display: none;
              }
            }
          }
        }
      }
    }
  }
  .riv-denied-c0 {
    fill: #818181;
  }
  .riv-details-c0 {
    fill: #818181;
  }
  .riv-fornitori-c0 {
    fill: @oroRiva;
  }
  .riv-docFornitore-c0 {
    fill: @oroRiva;
  }
</style>



// WEBPACK FOOTER //
// src/components/AccessoStabilimenti/GestioneAppalti/DocumentiRichiesti/Ricerca.vue